import { AddTrackWorkflowType } from '@jbrowse/core/pluggableElementTypes';
import { types } from 'mobx-state-tree';
// locals
import MultiWiggleWidget from './AddTrackWorkflow';
export default (function (pm) {
  pm.addAddTrackWorkflowType(function () {
    return new AddTrackWorkflowType({
      name: 'Multi-wiggle track',
      ReactComponent: MultiWiggleWidget,
      stateModel: types.model({})
    });
  });
});